import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Detector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

function init(resources) {
  const l =
    process.env.REACT_APP_API_ROOT +
    '/Y4/GetByServlet?servlet=WebUiFalcon&command=GetTranslation&lng={{lng}}&ns={{ns}}';

  const a =
    process.env.REACT_APP_API_ROOT +
    '/Y4/PostToServlet?servlet=WebUiFalcon&command=AddTranslation&lng={{lng}}&ns={{ns}}';

  const backend_options = {
    ns: ['auth'],
    nsSeparator: ':',
    crossDomain: true,
    loadPath: l,
    addPath: a,
    parse: function (data) {
      const jo = JSON.parse(data);
      return jo.data;
    },
    parsePayload: function (namespace, key) {
      return {
        servlet: 'WebUiFalcon',
        command: 'AddTranslation',
        key,
        namespace
      };
    }
  };

  i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(Detector)
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next) // passes i18n down to react-i18next
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init(
      {
        resources,
        debug: false,
        backend: backend_options,
        fallbackLng: 'en', // use en if detected lng is not available
        saveMissing: true, // send not translated keys to endpoint
        lng: 'zh-CN', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option
        interpolation: {
          escapeValue: false // react already safes from xss
        },
        react: {
          useSuspense: false
        }
      },
      (err, t) => {
        document.title = t('Browser title');
      }
    );
}

export { init };
